import { ServiceComboDisplaySettingsModel } from "@/Administration/Models/Settings/ServiceComboDisplaySettingsModel";
import { ServiceComboDefinitionModel } from "@/Common/Models/Services/ServiceComboDefinitionModel";
import { ServiceDefinitionModel } from "@/Common/Models/Services/ServiceDefinitionModel";
import { ServiceComboDefinitionItemDTO } from "@/Common/Models/Services/ServiceOrComboTableItem";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { UserSettings } from "@/Globals/Models/UserSettings";

class ServiceComboAdministrationAction extends BaseAction {
    public RefreshEmployeeServices(): void {
        cacheStore.actions.refreshServicesAndLookups();
    }

    public SaveDisplaySettings(model: ServiceComboDisplaySettingsModel, onSuccess: () => void): void {
        const userSettings = new UserSettings();
        userSettings.ServiceComboDisplay = model;

        const requestData =
        {
            UserSettings: userSettings,
            UserId: sessionStore.userId
        };

        this.Execute(
            ServerOperations.Server.Myle_UpdateUserSettings,
            requestData,
            null,
            null,
            () => { },
            () => onSuccess()
        );
    }

    public SaveServiceDefinition(serviceDefinition: ServiceDefinitionModel, fillInOnlineDescriptions: boolean = false): void {
        if (fillInOnlineDescriptions) {
            if (!IsNullOrWhiteSpace(serviceDefinition.OnlineNameLookupId)) {
                let lookup = cacheStore.GetLookupById(serviceDefinition.OnlineNameLookupId);
                serviceDefinition.OnlineNameEN = lookup.en;
                serviceDefinition.OnlineNameFR = lookup.fr;
                serviceDefinition.OnlineNameES = lookup.esMX;
            }
            if (!IsNullOrWhiteSpace(serviceDefinition.OnlineDescriptionLookupId)) {
                let lookup = cacheStore.GetLookupById(serviceDefinition.OnlineDescriptionLookupId);
                serviceDefinition.OnlineDescriptionEN = lookup.en;
                serviceDefinition.OnlineDescriptionFR = lookup.fr;
                serviceDefinition.OnlineDescriptionES = lookup.esMX;
            }
            if (!IsNullOrWhiteSpace(serviceDefinition.OnlineDisclaimerLookupId)) {
                let lookup = cacheStore.GetLookupById(serviceDefinition.OnlineDisclaimerLookupId);
                serviceDefinition.OnlineDisclaimerEN = lookup.en;
                serviceDefinition.OnlineDisclaimerFR = lookup.fr;
                serviceDefinition.OnlineDisclaimerES = lookup.esMX;
            }
        }

        var requestData = {
            ServiceDefinition: {
                Id: serviceDefinition.Model.Id,
                DefaultDuration: serviceDefinition.Model.DefaultDuration,
                SpecializationLookupId: serviceDefinition.Model.SpecializationLookupId,
                SiteId: serviceDefinition.Model.SiteId,
                NameLookupId: serviceDefinition.Model.NameLookupId,
                Name: {
                    En: serviceDefinition.NameEN,
                    Fr: serviceDefinition.NameFR,
                    Es: serviceDefinition.NameES
                },
                OnlineNameLookupId: serviceDefinition.OnlineNameLookupId,
                OnlineName: {
                    En: serviceDefinition.OnlineNameEN,
                    Fr: serviceDefinition.OnlineNameFR,
                    Es: serviceDefinition.OnlineNameES
                },
                OnlineDescriptionLookupId: serviceDefinition.OnlineDescriptionLookupId,
                OnlineDescription: {
                    En: serviceDefinition.OnlineDescriptionEN,
                    Fr: serviceDefinition.OnlineDescriptionFR,
                    Es: serviceDefinition.OnlineDescriptionES
                },
                OnlineDisclaimerLookupId: serviceDefinition.OnlineDisclaimerLookupId,
                OnlineDisclaimer: {
                    En: serviceDefinition.OnlineDisclaimerEN,
                    Fr: serviceDefinition.OnlineDisclaimerFR,
                    Es: serviceDefinition.OnlineDisclaimerES
                },
                OnlineGroupId: serviceDefinition.OnlineGroupId,
                EmployeesContactFacetIds: serviceDefinition.Employees.map(x => x.ContactFacetId),
                Price: serviceDefinition.Model.Price || 0,
                IsServiceUrgent: serviceDefinition.Model.IsServiceUrgent,
                OnlineClienenteleCible: serviceDefinition.Model.OnlineClienenteleCible,
                PublishingRule: serviceDefinition.Model.PublishingRule,
                PublishingTimeframe: serviceDefinition.Model.PublishingTimeframe,
                IsAvailableOnline: serviceDefinition.Model.IsAvailableOnline,
                IsNotifyPatientDisabledByDefault: serviceDefinition.Model.IsNotifyPatientDisabledByDefault,
                IsTeleconsultation: serviceDefinition.Model.IsTeleconsultation,
                QuestionnaireId: serviceDefinition.Model.QuestionnaireId
            }
        };

        this.Execute(ServerOperations.Server.Myle_AdministrationUpsertService, requestData);
    }

    public SaveComboDefinition(comboDefinition: ServiceComboDefinitionModel, fillInOnlineDescriptions: boolean = false): void {
        var serviceItemsDTO: ServiceComboDefinitionItemDTO[] = [];

        for (var i = 0; i < comboDefinition.ServiceDefinitions.length; i++) {
            let newItem = new ServiceComboDefinitionItemDTO();
            newItem.Position = i + 1;
            newItem.ServiceDefinitionId = comboDefinition.ServiceDefinitions[i].Model.Id;
            serviceItemsDTO.push(newItem);
        }

        if (fillInOnlineDescriptions) {
            if (!IsNullOrWhiteSpace(comboDefinition.OnlineNameLookupId)) {
                let lookup = cacheStore.GetLookupById(comboDefinition.OnlineNameLookupId);
                comboDefinition.OnlineNameEN = lookup.en;
                comboDefinition.OnlineNameFR = lookup.fr;
                comboDefinition.OnlineNameES = lookup.esMX;
            }
            if (!IsNullOrWhiteSpace(comboDefinition.OnlineDescriptionLookupId)) {
                let lookup = cacheStore.GetLookupById(comboDefinition.OnlineDescriptionLookupId);
                comboDefinition.OnlineDescriptionEN = lookup.en;
                comboDefinition.OnlineDescriptionFR = lookup.en;
                comboDefinition.OnlineDescriptionES = lookup.esMX;
            }
            if (!IsNullOrWhiteSpace(comboDefinition.OnlineDisclaimerLookupId)) {
                let lookup = cacheStore.GetLookupById(comboDefinition.OnlineDisclaimerLookupId);
                comboDefinition.OnlineDisclaimerEN = lookup.en;
                comboDefinition.OnlineDisclaimerFR = lookup.en;
                comboDefinition.OnlineDisclaimerES = lookup.esMX;
            }
        }

        var requestData = {
            ServiceComboDefinition: {
                Id: comboDefinition.Model.ComboId,
                SpecializationLookupId: comboDefinition.Model.SpecializationLookupId,
                NameLookupId: comboDefinition.Model.NameLookupId,
                Name: {
                    En: comboDefinition.NameEN,
                    Fr: comboDefinition.NameFR,
                    Es: comboDefinition.NameES
                },
                OnlineNameLookupId: comboDefinition.OnlineNameLookupId,
                OnlineName: {
                    En: comboDefinition.OnlineNameEN,
                    Fr: comboDefinition.OnlineNameFR,
                    Es: comboDefinition.OnlineNameES
                },
                OnlineDescriptionLookupId: comboDefinition.OnlineDescriptionLookupId,
                OnlineDescription: {
                    En: comboDefinition.OnlineDescriptionEN,
                    Fr: comboDefinition.OnlineDescriptionFR,
                    Es: comboDefinition.OnlineDescriptionES
                },
                OnlineDisclaimerLookupId: comboDefinition.OnlineDisclaimerLookupId,
                OnlineDisclaimer: {
                    En: comboDefinition.OnlineDisclaimerEN,
                    Fr: comboDefinition.OnlineDisclaimerFR,
                    Es: comboDefinition.OnlineDisclaimerES
                },
                OnlineGroupId: comboDefinition.OnlineGroupId,
                IsAvailableOnline: comboDefinition.Model.IsAvailableOnline,
                IsServiceUrgent: comboDefinition.Model.IsServiceUrgent,
                OnlineClienenteleCible: comboDefinition.Model.OnlineClienenteleCible,
                PublishingRule: comboDefinition.Model.PublishingRule,
                PublishingTimeframe: comboDefinition.Model.PublishingTimeframe,
                Price: comboDefinition.Model.Price,
                ServiceDefinitionIds: serviceItemsDTO,
                PrimaryServiceDefinitionId: comboDefinition.PrimaryServiceDefinitionId,
                IsPriceIncludingTaxes: comboDefinition.Model.IsPriceIncludingTaxes,
                IsNotifyPatientDisabledByDefault: comboDefinition.Model.IsNotifyPatientDisabledByDefault,
                SiteId: comboDefinition.Model.SiteId,
                IsTeleconsultation: comboDefinition.Model.IsTeleconsultation,
                QuestionnaireId: comboDefinition.Model.QuestionnaireId
            }
        };

        this.Execute(ServerOperations.Server.Myle_AdministrationUpsertCombo, requestData);
    }

    public RefreshLookups(): void {
        cacheStore.actions.refreshLookups();
    }

    public RefreshEmployees(): void {
        cacheStore.actions.refreshServicesAndLookups();
    }
}

export { ServiceComboAdministrationAction };
